import { FormSchema } from 'components/Wizards/Wizard/Form/Types'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { object } from 'yup'

/*
 * This function takes in a FormSchema and returns a modified FormSchema.
 * The modified FormSchema will have a hidden topic field and updated schema meta.
 */
export const turnIntoSchemaModifier = <T extends FormSchema | MultiStepSchema | StepSchema>(schema: T): T => {
  if (isMultiStepSchema(schema)) {
    return {
      ...schema,
      steps: (schema as MultiStepSchema).steps.map((step) => turnIntoSchemaModifier(step)) as StepSchema[],
    } as T
  } else {
    const { fields } = (schema as FormSchema | StepSchema).describe()
    const fieldNames = Object.keys(fields)

    if (!fieldNames.includes('topic')) {
      return schema
    }
    const modifiedTopic = topic.meta({
      ...topic.describe().meta,
      hide: true,
    })

    // Concatenate the modified topic field and add autofillAutomatically to the schema meta
    return (schema as FormSchema | StepSchema)
      .concat(
        object({
          topic: modifiedTopic,
        }),
      )
      .meta({
        ...(schema as FormSchema | StepSchema).describe().meta,
        autofillAutomatically: true,
      }) as unknown as T
  }
}

const isMultiStepSchema = (schema: FormSchema | MultiStepSchema | StepSchema): boolean => {
  return 'steps' in schema
}
